import React, {
  ReactElement,
  useEffect,
  useRef,
  useState,
  Fragment,
} from 'react';
import Tooltip from '@mui/material/Tooltip';

export const SetAddressLineCell = ({ props }: { props: any }): ReactElement => {
  const divRef = useRef(null);
  const [tooltip, setTooltip] = useState(false);

  function getDivWidth(divRef: any) {
    if (divRef && divRef.current) {
      const divElement = divRef.current;
      const parentElement = divElement.parentNode;

      const divRect = divElement.getBoundingClientRect();
      const parentRect = parentElement.getBoundingClientRect();

      return {
        element: divRect.width,
        cell: parentRect.width,
      };
    }
    return {
      element: 0,
      cell: 0,
    };
  }

  useEffect(() => {
    setTooltip(false);
    const divWidth: { element: number; cell: number } = getDivWidth(divRef);

    if (divWidth['element'] > divWidth['cell']) {
      setTooltip(true);
    }
  });
  const tags = props.value;

  if (tags === undefined || tags === null) {
    return <></>;
  }

  const names = tags.map(function (item: any) {
    return item?.address_line1 ? item?.address_line1 : '';
  });

  return (
    <div
      ref={divRef}
      className={`${tooltip ? 'has-tooltip' : 'doesnthave-tooltip'}`}
    >
      {tooltip ? (
        <>
          <Tooltip
            disableInteractive
            title={names.join(',')}
            slotProps={{
              tooltip: {
                sx: {
                  fontSize: '13px',
                },
              },
              popper: {
                modifiers: [
                  {
                    name: 'offset',
                    options: {
                      offset: [0, -14],
                    },
                  },
                ],
              },
            }}
          >
            <div
              style={{
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
              }}
            >
              {names.join(',')}
            </div>
          </Tooltip>
        </>
      ) : (
        <>{names.join(',')}</>
      )}
    </div>
  );
};
